import * as React from 'react';

type TextButtonProps = {
  testId?: string;
  headerText?: string;
  text: string;
  type:
    | 'primary'
    | 'secondary'
    | 'tertiary'
    | 'primary-text-only'
    | 'text-only'
    | 'danger';
  title?: string;
  disabled?: boolean;
  'aria-pressed'?: boolean;
  id?: string;
  classNames?: string;
  iconClass?: string;
  outlineOnly?: boolean;
  onClick: () => void;
};

export const TextButton = ({
  testId,
  headerText,
  text,
  type,
  title,
  disabled,
  'aria-pressed': ariaPressed,
  id,
  classNames = '',
  iconClass,
  outlineOnly = false,
  onClick
}: TextButtonProps) => {
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (disabled) {
      e.preventDefault();
      return;
    }
    onClick();
  };

  return (
    <button
      id={id}
      className={`text-button ${type} ${
        outlineOnly ? 'outline-only' : ''
      } ${classNames}`}
      onClick={handleClick}
      title={title}
      disabled={disabled}
      aria-pressed={ariaPressed}
      role="button"
      data-testid={
        testId
          ? testId
          : `text-button-${text.toLowerCase().replace(/\s+/g, '-')}`
      }
    >
      {iconClass && (
        <span className={'fa-light ' + iconClass} aria-hidden="true"></span>
      )}
      <span className="text-button__text">
        {headerText && (
          <span className="text-button__text__header">{headerText}</span>
        )}
        <span className="text-button__text__body">{text}</span>
      </span>
    </button>
  );
};
